import { render } from "./ReportesHeader.vue?vue&type=template&id=22ad8082&scoped=true"
import script from "./ReportesHeader.vue?vue&type=script&lang=js"
export * from "./ReportesHeader.vue?vue&type=script&lang=js"

import "./ReportesHeader.vue?vue&type=style&index=0&id=22ad8082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad8082"]])

export default __exports__